import React, { useContext } from 'react';
import { AppContext } from '@ctsu/loader';
import { ErrorBoundary } from 'react-error-boundary';

export function FallBackError() {
  return <div className="loading-error">Oops! Something went wrong!!!</div>;
}

const OnErrorHandler = (context) => (error, componentStack) => {
  const { logError, logInfo } = context;
  try {
    logError(context, 'An Error Occured in Regulatory Application', componentStack, {}, {}, error);
  } catch (err) {
    logInfo(err);
  }
};

function CTSUErrorBoundary({ children }) {
  const context = useContext(AppContext);
  return (
    <ErrorBoundary FallbackComponent={FallBackError} onError={OnErrorHandler(context)}>
      {children}
    </ErrorBoundary>
  );
}

export default CTSUErrorBoundary;
